import {
    title,
    description,
    mrAuto,
    mlAuto,
    infoColor,
} from "assets/jss/material-kit-pro-react.js";
import customSelectStyle from "assets/jss/material-kit-pro-react/customSelectStyle.js";

const orderSageOnePageStyle = {
    title,
    mrAuto,
    mlAuto,
    ...customSelectStyle,
    description: {
        ...description,
        marginBottom: "70px",
    },
    textCenter: {
        textAlign: "center!important",
    },
    selectUnderlineRoot: {
        "& > div": {
            marginTop: "13px",
        },
    },
    aboutUs: {
        padding: "80px 0px",
    },
    boxArea: {
        textAlign: "center!important",
        display: "inline-block",
        padding: "0px",
        width: "100%",
    },

    containerForm: {
        display: 'flex',
        flexWrap: 'wrap',
        backgroundColor: '#e0e0e0',
        width: "100%",
        padding: "80px 0px",
    },
    menu: {
        width: "200px"
    },

    right: {
        padding: "15px 0",
        margin: "0",
        float: "right!important",
        display: "block",
    },

    left: {
        padding: "15px 0",
        float: "left!important",
        display: "block",
        margin: 0
    },
    iconHolder: {
        padding: "25px 0px 10px 0px",
        textAlign: "center"
    },

    weightIcons: {
        height: '70px ',
        width: '170px'
    }
    ,
    textCenter: {
        textAlign: "center",
    },
    textRight: {
        textAlign: "right",
    },

   
};

export default orderSageOnePageStyle;
